import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
  Button,
  Paper,
  Container,
  IconButton,
} from "@mui/material";
import CollectionsIcon from "@mui/icons-material/Collections";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { ChangeModal } from "../reward/ChangeModal";
import ImageZoomModal from "./ImageZoomModal";
import { CouponData, FlyerData, RallyData } from "../../type";
import main from "../../assets/scss/main.module.scss";

export const IssuerItemList = ({
  itemList,
  type,
  issuerId,
}: {
  itemList: FlyerData[] | CouponData[] | RallyData[];
  type: "flyer" | "coupon" | "rally";
  issuerId?: string;
}) => {
  const navigate = useNavigate();

  const [zoomImgIndex, setZoomImgIndex] = useState<number | undefined>();
  const [selectedFlyer, setSelectedFlyer] = useState<number>(0);
  const [isPointSpendModalOpen, setIsPointSpendModalOpen] =
    useState<boolean>(false);
  const [selectReward, setSelectReward] = useState<CouponData>();

  return (
    <>
      {itemList.map((item, index) => (
        <Paper
          key={index}
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            position: "relative",
            m: 1,
            p: 1,
            borderRadius: "8px",
          }}
        >
          <Box sx={{ position: "relative" }}>
            {item?.urls?.length && (
              <img
                src={item.urls[0]}
                alt=""
                style={{
                  width: "100px",
                  height: "100px",
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setSelectedFlyer(index);
                  setZoomImgIndex(0);
                }}
              />
            )}
            {item?.urls?.length > 1 && (
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  color: "#fff",
                  borderRadius: "50%",
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CollectionsIcon fontSize="small" />
              </Box>
            )}
          </Box>
          {type === "flyer" && (
            <Box sx={{ flex: 1 }}>
              <Typography sx={{ textAlign: "left" }}>
                {(item as FlyerData).content}
              </Typography>
              {(item as FlyerData).issuerId &&
                (item as FlyerData).issuerName && (
                  <Typography
                    variant="caption"
                    sx={{
                      display: "block",
                      width: "100%",
                      textAlign: "right",
                      mt: 1,
                      color: main.colorDarkGreen,
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      navigate(`/map/${(item as FlyerData).issuerId}`)
                    }
                  >
                    {(item as FlyerData).issuerName}
                  </Typography>
                )}
            </Box>
          )}
          {type === "coupon" && (
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: "bold", textAlign: "left" }}>
                {(item as CouponData).name}
              </Typography>
              <Container
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: 2,
                  p: 0,
                }}
              >
                <Typography>{(item as CouponData).point}pt</Typography>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setIsPointSpendModalOpen(true);
                    setSelectReward(item as CouponData);
                  }}
                  sx={{ my: 1, fontWeight: "bold" }}
                >
                  交換
                </Button>
              </Container>
            </Box>
          )}
          {type === "rally" && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                height: "60px",
              }}
              onClick={() => {
                navigate(`/rally/${(item as RallyData).uuid}`, {
                  state: { issuerId: issuerId },
                });
              }}
            >
              <Typography sx={{ textAlign: "left", my: "auto" }}>
                {(item as RallyData).name}
              </Typography>
              <Typography>
                <ArrowForwardIosIcon color="primary" />
              </Typography>
            </Box>
          )}
        </Paper>
      ))}
      <ImageZoomModal
        urls={itemList[selectedFlyer]?.urls || []}
        zoomImgIndex={zoomImgIndex}
        setZoomImgIndex={setZoomImgIndex}
      />
      <ChangeModal
        isPointSpendModalOpen={isPointSpendModalOpen}
        setIsPointSpendModalOpen={setIsPointSpendModalOpen}
        selectReward={selectReward}
      />
    </>
  );
};
